/**
 * Messages a cross-origin script error can arrive with. The browser sanitizes
 * the message of an error thrown by a script loaded without CORS headers to
 * "Script error.". `window.onerror` then hands the Datadog SDKs that string
 * with no Error object, so they report it as a non-Error value and prefix it:
 * `Uncaught "Script error."`.
 */
export const CROSS_ORIGIN_SCRIPT_ERROR_MESSAGES: ReadonlySet<string> = new Set([
  "Script error.",
  'Uncaught "Script error."',
]);

/** The stub frame the SDKs build when the browser gives them no location. */
export const NON_ATTRIBUTABLE_FRAME_MARKER = "at undefined @ ";
